import { render, staticRenderFns } from "./RequiredInfosUser.vue?vue&type=template&id=3415dc04&"
import script from "./RequiredInfosUser.vue?vue&type=script&lang=js&"
export * from "./RequiredInfosUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports